<template>
    <div class="hasBackStyle">
        <div class="page container" data-page="leaderboard">

            <!--Breadcrumbs-->
            <div class="breadcrumbs">
                <router-link to="/">Home</router-link>
                <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
                <router-link to="/members">Members</router-link>
                <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
                <router-link to="/leaderboard">Leaderboard</router-link>
            </div>
            
            <div class="leaderboard">

                <h1>Leaderboard</h1>

                <div class="howWorks">
                    
                    <h3>How does points work?</h3>
                    <p>Collect points throughout the year. The top 3 will get a <strong>OneMgl specialized gift</strong> at our New Year Party celebration.</p>
                    
                    <div class="howWorksSteps pure-g">
                        <div class="pure-u-1 pure-u-lg-1-3 step">
                            <h3>1</h3>
                            <p>Must be a Member!</p>
                        </div>
                        <div class="pure-u-1 pure-u-lg-1-3 step">
                            <h3>2</h3>
                            <p>Join a an Event</p>
                        </div>
                        <div class="pure-u-1 pure-u-lg-1-3 step">
                            <h3>3</h3>
                            <p>Collect 1 point for every event</p>
                        </div>
                        <div class="pure-u-1 back"></div>
                    </div>
                </div>
                
                <MembersList v-if="showLeaderboard" type="leaderboard" :data="eventMemberPoints"></MembersList>

                <Membership></Membership>
                
            </div>
        </div>
        <svg class="item2" xmlns="http://www.w3.org/2000/svg" width="368.256" height="396.554" viewBox="0 0 368.256 396.554"><g transform="translate(0.256 -524)"><path d="M180.793,0C303.5,0,402.975,99.474,402.975,222.181a221.617,221.617,0,0,1-24.022,100.592.933.933,0,0,0,0,1.023H101.529s-1.4-.619-2.277-1.023C85.9,319.28,83.527,309.858,81.8,303.518a10.862,10.862,0,0,1,0-2.043V24.373s-.065-1.137,2.323-2.3A221.06,221.06,0,0,1,180.793,0Z" transform="translate(-82 596.758)" fill="#ffc107" opacity="0.698"/><circle cx="119" cy="119" r="119" transform="translate(130 524)" fill="#34aa59"/></g></svg>
    </div>
</template>

<script>
    const fb = require('../firebaseConfig.js')
    import MembersList from '../components/MembersList.vue'
    import Membership from '../components/Membership.vue'
    import moment from 'moment'

    export default {
        components: {
            MembersList,
            Membership
        },
        data(){
            return{
                showLeaderboard: false,
                eventMemberPoints: {}
            }
        },
        beforeMount(){

            let self = this
            let eventsRef = fb.eventsCollection
            
            this.$prismic.client.query(
                this.$prismic.Predicates.at('document.type', 'events'),
                {
                    orderings: '[my.events.date_and_time_to, my.events.date_and_time]'
                }
            ).then((response) => {

                response.results.forEach((event, index) => {
                    if(self.isEventFinished(event) === 'Event Finished'){
                    
                        let eventRef = fb.eventsCollection.doc(event.uid).collection('members')
                    
                        eventRef.get().then(snap => {
                            snap.forEach(member => {
                                if(typeof(self.eventMemberPoints[member.id]) !== 'undefined' && self.eventMemberPoints[member.id] !== null){
                                    self.eventMemberPoints[member.id].points += 1
                                }else{
                                    self.eventMemberPoints[member.id] = {
                                        points: 1
                                    }
                                }
                            })
                        })
                    }
                })
            }).then(() => {
                this.showLeaderboard = true
                // this.updateMemberPoints()
            })
        },
        methods: {
            isEventFinished(myEvent){

                console.log('Event: ', myEvent)

                let today = moment()
                let start_date = moment(myEvent.data.date_and_time)
                let end_date = null
                let eventStatus = 'Event Not Started'

                // Event has end date
                if(myEvent.data.date_and_time_to !== null){

                    end_date = moment(myEvent.data.date_and_time_to)

                    if(today.isAfter(start_date) && today.isBefore(end_date)){
                        eventStatus = 'Event In Progress'
                    }
                    if(today.isAfter(end_date)){
                        eventStatus = 'Event Finished'
                    }
                // Event has no end date
                }else{
                    if(today.isAfter(start_date)){
                        eventStatus = 'Event Finished'
                    }
                }

                return eventStatus
            },
            updateMemberPoints(){

                // Batch Update
                let self = this
                let allUsers = this.$store.state.allUsers

                if(allUsers !== null){
                    
                    let batch = fb.db.batch()

                    Object.keys(allUsers).forEach((key, index) => {

                        let user = allUsers[key]
                        let userRef = fb.usersCollection.doc(user.uid)
                        
                        // batch.update(userRef, {
                        //     'settings': {
                        //         'sendEmail': sendEmail,
                        //         'sendTxt': sendTxt
                        //     }
                        // })

                        // console.log('User: ', user.displayName)
                    })

                    // batch.commit().then(function(){
                    //     console.log('Batch successfull!')
                    //     self.showLeaderboard = true
                    // })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Leaderboard.vue